import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';

import {
  LandingWithVideo,
  ScalableVideo,
  WhatsNew,
  Dominate,
} from 'modules/newHomepage';
import { SEO } from 'main/components';

export const NewHomepage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobileCheck = window.innerWidth <= 767;
      setIsMobile(prev => (prev !== mobileCheck ? mobileCheck : prev));
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className="newhomepage-section">
      <SEO
        seoTitle="FPV Drone - Mission-Ready Aerial Robotics - Orqa"
        seoDescription="Orqa d.o.o. was founded in 2018..."
      />

      <LandingWithVideo isMobile={isMobile} />
      <Dominate />
      <ScalableVideo isMobile={isMobile} />
      <WhatsNew />
    </section>
  );
};

export default withRouter(NewHomepage);
